import {
    CheckboxLabel,
    TermsLink,
} from '@/src/modules/checkout/forms/StyledComponents'

const TermsAndConditions = () => {
    return (
        <CheckboxLabel>
            By placing an order, you agree to BuyGiftCards.com&apos;s{' '}
            <TermsLink href="/terms-of-service" target="_blank">
                Terms of Service
            </TermsLink>
            ,{' '}
            <TermsLink href="/terms-of-use" target="_blank">
                Terms of Use
            </TermsLink>
            , and{' '}
            <TermsLink href="/privacy-policy" target="_blank">
                Privacy Policy
            </TermsLink>
            .
        </CheckboxLabel>
    )
}
export default TermsAndConditions
